var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2",class:{alternative: _vm.alternative},attrs:{"id":"alcor-container"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }